export class History
{
    static push_url(url, title, skipReplace)
    {
        if(!skipReplace && history.state)
        {
            // replace current url with scroll position
            // set current searchterm if available
            History.replace_url(true)
        }

        // push new url
        history.pushState({
            v: url,
            scrollY: 0
        }, title, url);

        // update return url for ISE
        if(document.body.dataset.ise === 'on')
        {
            const iseExit = document.body.querySelector('.ise.ise--exit');
            if(iseExit)
            {
                iseExit.href = iseExit.href.replace(/url=.*/, 'url=' + document.location.pathname);
            }
        }
    }

    static replace_url(storeScroll)
    {
        const data = {
            scrollY: 0
        };

        data.v = (document.documentURI && document.documentURI !== "undefined")
            ? document.documentURI
            : document.location.pathname;

        if(storeScroll === true)
        {
            data.scrollY = window.scrollY;
        }

        history.replaceState(data,'', data.v);
    }

    static replace_url(storeScroll)
    {
        const data = {
            scrollY: 0
        };

        data.v = (document.documentURI && document.documentURI !== "undefined")
            ? document.documentURI
            : document.location.pathname;

        if(storeScroll === true)
        {
            data.scrollY = window.scrollY;
        }

        history.replaceState(data,'', data.v);
    }

    static add_event()
    {
        window.addEventListener('popstate',e =>
        {
            if(e.state && e.state.v)
            {
                document.location = e.state.v;
            }
        });
    }
}
